import React from "react";

import styles from "../../../styles/orders.module.scss";

import {
  OrdersDeliveryIcon,
  OrdersFinishedIcon,
  OrdersProductionIcon,
} from "../../../shared/components/Icons";

import OrderCard from "../../../shared/containers/Orders/OrderCard";
import OrderDetails from "../../../shared/containers/Orders/OrderDetails";

import debounce from "lodash.debounce";
import { EnvironmentsAPI } from "../../../providers/EnvironmentsAPI";
import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { OrderAPI } from "../../../providers/OrderAPI";
import { OrdersAPI } from "../../../providers/OrdersAPI";
import { Button } from "../../../shared/components/Button";
import { Checkbox } from "../../../shared/components/Checkbox";
import { Drawer } from "../../../shared/components/Drawer";
import { InputSearch } from "../../../shared/components/InputSearch";
import { Label } from "../../../shared/components/Label";
import { Loading } from "../../../shared/components/Loading";
import { Title } from "../../../shared/components/Title";
import { Icon } from "../../../shared/components/core/Icon";
import { OrderCancellationDrawer } from "../../../shared/containers/Orders/OrderCancellationDrawer";
import OrderFilterByDate from "../../../shared/containers/Orders/OrderFilterByDate";
import { EnvironmentStorage } from "../../../shared/tools/EnvironmentStorage";
import { UserStorage } from "../../../shared/tools/UserStorage";
import { Tabs } from "@components";
import { If } from "shared/components/control-statements";

const tabs = {
  IN_PRODUCTION: {
    key: "production",
    name: "Produção",
  },
  ON_DELIVERY: {
    key: "delivery",
    name: "Entrega",
  },
  FINISHED: {
    key: "finished",
    name: "Fin/Canc",
  },
};

const getIcon = (id) => {
  const icons = {
    1: <OrdersProductionIcon />,
    2: <OrdersDeliveryIcon />,
    3: <OrdersFinishedIcon />,
  };

  return icons[id];
};

const OrderStatus = {
  IN_PRODUCTION: "IN_PRODUCTION",
  ON_DELIVERY: "ON_DELIVERY",
  FINISHED: "FINISHED",
};

const shippingHubDeliveryTypes = {
  IFOOD_DELIVERY: "IFOOD_DELIVERY",
  MOTTU: "MOTTU",
};

export default class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: {},
      order: {},
      openOrderDetails: false,
      openFilter: false,
      openOptions: false,
      openOrderCancellation: false,
      orderCancellationCodes: [],
      close: false,
      automaticOrderAccept: false,
      refreshOrdersAuto: false,
      allowManualDispatch: false,
      savingOptions: false,
      loaderRef: React.createRef(),
      nextPage: 0,
      hasMore: true,
      searchTerm: "",
      rangeFilterType: "",
      searchBegin: "",
      searchEnd: "",
      environment: {},
      orderGoing: null,
      canceled: null,
      rejected: null,
      counter: 0,
      observer: null,
      activeTab: "production",
    };
  }

  setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  loadOrders = async () => {
    try {
      // carrega as primeiras informações das orders e renderiza
      const response = await OrdersAPI.getOrders({});
      const data = response.getData({
        items: { OPENED: [], IN_PRODUCTION: [], ON_DELIVERY: [], FINISHED: [] },
        count: { OPENED: 1, IN_PRODUCTION: 0, ON_DELIVERY: 0, FINISHED: 0 },
        page: { next: -1 },
      });

      const { items, count, page } = data;

      const orderList = {
        production: {
          id: 1,
          name: "Produção",
          count: count.IN_PRODUCTION,
          orders: items.IN_PRODUCTION,
        },
        delivery: {
          id: 2,
          name: "Entrega",
          count: count.ON_DELIVERY,
          orders: items.ON_DELIVERY,
        },
        finished: {
          id: 3,
          name: "Finalizado / Cancelado",
          count: count.FINISHED,
          orders: items.FINISHED,
        },
      };

      this.setState((prevState) => ({
        counter: prevState.counter + 1,
      }));

      this.setState({
        orders: orderList,
        totalOrders: count.IN_PRODUCTION + count.ON_DELIVERY + count.FINISHED,
      });
    } catch (error) {
      console.log(error);
    }
  };

  async componentDidMount() {
    this.setState({
      environment: EnvironmentStorage.getEnvironment(),
    });

    const selectedEnvironment = EnvironmentStorage.getSelectedEnvironment();
    const responseConfiguration =
      await EnvironmentsAPI.getConfigurationsAutomaticOrderAccept(
        selectedEnvironment
      );
    const automaticOrderAccept = responseConfiguration.getData({
      enabled: false,
    }).enabled;
    this.setState({ automaticOrderAccept });

    const configurations = EnvironmentStorage.getConfigurations();

    const refreshOrdersAuto = localStorage.getItem(
      `${configurations.parent_alias}-refreshOrdersAuto`
    );

    this.setState({ refreshOrdersAuto: refreshOrdersAuto || false });

    const shippingHubConfig = await EnvironmentsAPI.getConfigurationsByAlias(
      selectedEnvironment,
      "shippinghub"
    );
    const allowManualDispatch =
      !!shippingHubConfig?.gatewayType &&
      shippingHubConfig?.allowManualDispatch;
    this.setState({ allowManualDispatch });

    await this.loadOrders();

    this.createLoadingObserver();

    window.addEventListener("orderAccepted", this.onOrderAccepted.bind(this));
    window.addEventListener(
      "ORDER_STATUS_CHANGED",
      this.onOrderAccepted.bind(this)
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      "orderAccepted",
      this.onOrderAccepted.bind(this)
    );
    window.removeEventListener(
      "ORDER_STATUS_CHANGED",
      this.onOrderAccepted.bind(this)
    );
  }

  createLoadingObserver() {
    // observer é responsável por ficar olhando o loadRef no final dos itens, e assim que necessário, fazer a chamada da API
    this.observer = new IntersectionObserver(
      (entities) => {
        const target = entities[0];

        if (target.isIntersecting) {
          this.setState({
            nextPage: this.state.hasMore ? this.state.nextPage + 1 : -1,
          });
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 1.0,
      }
    );

    if (!this.state.loaderRef.current) {
      return;
    }

    this.observer.observe(this.state.loaderRef.current);
  }

  removeLoadingObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  async onOrderAccepted() {
    const { orders } = this.state;
    //Obtém a coluna com a maior quantidade de itens
    const columnCountMax = Math.max(
      ...Object.values(orders).map((o) => o.orders.length)
    );
    //Recarrega todos os itens já carregados desde a primeira página.
    await this.loadMoreOrders(0, columnCountMax + 1, true);
    this.setState({ nextPage: this.state.nextPage + 1 });
  }

  // função responsável pelo load de mais items
  async loadMoreOrders(pageNumber, limit = 10, force = false) {
    const {
      orders,
      hasMore,
      searchTerm,
      searchBegin,
      searchEnd,
      canceled,
      rejected,
    } = this.state;

    if (!force && !hasMore) {
      return;
    }

    const response = await OrdersAPI.getOrders({
      page: pageNumber,
      limit: limit || 10,
      term: searchTerm,
      begin: searchBegin,
      end: searchEnd,
      canceled,
      rejected,
    });

    const data = response.getData({
      items: { OPENED: [], IN_PRODUCTION: [], ON_DELIVERY: [], FINISHED: [] },
      count: { OPENED: 1, IN_PRODUCTION: 0, ON_DELIVERY: 0, FINISHED: 0 },
      page: { next: -1 },
    });

    const { items, count, page } = data;
    this.setState({
      hasMore: page.next != -1,
      orders: {
        production: {
          ...orders.production,
          count: count.IN_PRODUCTION,
          orders:
            pageNumber == 0
              ? items.IN_PRODUCTION
              : orders.production.orders.concat(items.IN_PRODUCTION),
        },
        delivery: {
          ...orders.delivery,
          count: count.ON_DELIVERY,
          orders:
            pageNumber == 0
              ? items.ON_DELIVERY
              : orders.delivery.orders.concat(items.ON_DELIVERY),
        },
        finished: {
          ...orders.finished,
          count: count.FINISHED,
          orders:
            pageNumber == 0
              ? items.FINISHED
              : orders.finished.orders.concat(items.FINISHED),
        },
      },
    });
  }

  // sempre que o nextPage atualizar, irá chamar a função para fazer o load de mais itens
  async componentDidUpdate(prevProps, prevState) {
    if (!prevState.hasMore && this.state.hasMore) {
      this.createLoadingObserver();
    }

    if (prevState.hasMore && !this.state.hasMore) {
      this.removeLoadingObserver();
    }

    if (prevState.nextPage !== this.state.nextPage) {
      this.loadMoreOrders(this.state.nextPage);
    }
  }

  async onChangeStatus(order, targetStatus) {
    const response = await OrderAPI.setStatus(order.id, targetStatus);
    const errors = response.getErrors([]);
    if (errors.length > 0) {
      alert({ text: errors[0], buttonText: "Ok" });
    } else {
      const { orders } = this.state;

      //Obtém a coluna com a maior quantidade de itens
      const columnCountMax = Math.max(
        ...Object.values(orders).map((o) => o.orders.length)
      );
      //Recarrega todos os itens já carregados desde a primeira página.
      await this.loadMoreOrders(0, columnCountMax + 1, true);
      this.setState({ nextPage: this.state.nextPage + 1 });
    }

    this.setState({ orderGoing: order.id });
  }

  async onDispatch(order) {
    const response = await OrderAPI.dispatchOrder(order.id);
    const errors = response.getErrors([]);
    if (errors.length > 0) {
      alert({ text: errors[0], buttonText: "Ok" });
    }

    const { orders } = this.state;
    //Obtém a coluna com a maior quantidade de itens
    const columnCountMax = Math.max(
      ...Object.values(orders).map((o) => o.orders.length)
    );
    //Recarrega todos os itens já carregados desde a primeira página.
    await this.loadMoreOrders(0, columnCountMax + 1, true);
    this.setState({ nextPage: this.state.nextPage + 1 });
  }

  async saveConfigurations() {
    const { automaticOrderAccept, refreshOrdersAuto, canceled, rejected } =
      this.state;
    await this.setAsyncState({ savingOptions: true });

    const configurations = EnvironmentStorage.getConfigurations();

    if (!!refreshOrdersAuto)
      localStorage.setItem(
        `${configurations.parent_alias}-refreshOrdersAuto`,
        "true"
      );
    else
      localStorage.removeItem(
        `${configurations.parent_alias}-refreshOrdersAuto`
      );

    window.dispatchEvent(new Event("refreshOrdersAuto"));

    const selectedEnvironment = EnvironmentStorage.getSelectedEnvironment();
    const response =
      await EnvironmentsAPI.putConfigurationsAutomaticOrderAccept(
        selectedEnvironment,
        automaticOrderAccept
      );
    const responseConfiguration =
      await EnvironmentsAPI.getConfigurationsAutomaticOrderAccept(
        selectedEnvironment
      );
    const newAutomaticOrderAccept = responseConfiguration.getData({
      enabled: false,
    }).enabled;

    if (response.getErrors([]).length == 0) {
      this.setState({
        openOptions: false,
        automaticOrderAccept: newAutomaticOrderAccept,
        savingOptions: false,
      });
    } else {
      this.setState({
        automaticOrderAccept: newAutomaticOrderAccept,
        savingOptions: false,
      });
    }

    this.searchByDate(null, null, canceled, rejected);
  }

  searchByDate = async (begin, end, canceled, rejected) => {
    this.setState({
      searchBegin: begin,
      searchEnd: end,
      canceled: canceled || this.state.canceled,
      rejected: rejected || this.state.rejected,
    });
    await this.searchOrders({ pageNumber: 0, begin, end, canceled, rejected });
  };

  async searchOrders({ pageNumber, term, begin, end, canceled, rejected }) {
    const { orders } = this.state;

    const response = await OrdersAPI.getOrders({
      page: pageNumber,
      term,
      begin: begin || this.state.searchBegin,
      end: end || this.state.searchEnd,
      canceled: canceled || this.state.canceled,
      rejected: rejected || this.state.rejected,
    });
    const data = response.getData({
      items: { OPENED: [], IN_PRODUCTION: [], ON_DELIVERY: [], FINISHED: [] },
      count: { OPENED: 1, IN_PRODUCTION: 0, ON_DELIVERY: 0, FINISHED: 0 },
      page: { next: -1 },
    });

    const { items, count, page } = data;
    this.setState({
      hasMore: page.next != -1,
      orders: {
        production: {
          ...orders.production,
          count: count.IN_PRODUCTION,
          orders: items.IN_PRODUCTION,
        },
        delivery: {
          ...orders.delivery,
          count: count.ON_DELIVERY,
          orders: items.ON_DELIVERY,
        },
        finished: {
          ...orders.finished,
          count: count.FINISHED,
          orders: items.FINISHED,
        },
      },
    });
  }

  render() {
    const {
      orders,
      order,
      orderCancellationCodes,
      openOrderDetails,
      openFilter,
      openOptions,
      openOrderCancellation,
      automaticOrderAccept,
      refreshOrdersAuto,
      savingOptions,
      hasMore,
      searchTerm,
      totalOrders,
      environment,
      canceled,
      rejected,
      activeTab,
    } = this.state;

    const { isMobile } = this.props;

    const closeDrawer = () => {
      this.setState({ openFilter: false });
    };

    const selectOrder = async (order) => {
      let cancellationCodes = [];

      if (
        [shippingHubDeliveryTypes.IFOOD_DELIVERY].includes(
          order?.delivery?.deliveryPlatformShipping
        )
      ) {
        try {
          const selectedEnvironment =
            EnvironmentStorage.getSelectedEnvironment();
          const responseCodeCancellation =
            await IntegrationsAPI.getOrderCancellationCode(
              order.id,
              selectedEnvironment
            );
          cancellationCodes = responseCodeCancellation.getData([]);
        } catch (err) {
          console.log(err);
        }
      }

      this.setState({
        openOrderDetails: true,
        order: order,
        orderCancellationCodes: cancellationCodes,
      });
    };

    const cancelOrder = async (order) => {
      if (orderCancellationCodes.length > 0) {
        this.setState({
          openOrderDetails: false,
          openOrderCancellation: true,
        });
      } else {
        await this.onChangeStatus(order, "CANCELED");
        this.setState({ openOrderDetails: false });
      }
    };

    const scrollTo = (e, index) => {
      const item = document.querySelector(`.column-${index}`);
      e.target.scrollIntoView({
        block: "nearest",
        inline: "center",
        behavior: "smooth",
      });
    };

    const searchByTerm = async (e) => {
      const searchTerm = (e.target.value || "").toLowerCase();
      const { searchBegin, searchEnd, canceled, rejected } = this.state;
      this.setState({ searchTerm: searchTerm, nextPage: 0 });
      await this.searchOrders({
        pageNumber: 0,
        term: searchTerm,
        begin: searchBegin,
        end: searchEnd,
        canceled,
        rejected,
      });
    };

    const clearSearchDate = async () => {
      this.setState({ searchBegin: "", searchEnd: "" });
      await this.searchOrders({ pageNumber: 0 });
    };

    const getSubtitle = () => {
      if (environment?.brand)
        return (
          `${environment.brand.name} - ${environment.name}` +
          (environment.active === false ? " (Inativa)" : "")
        );
      return environment?.name;
    };

    return (
      <div className={styles.ordersContainer}>
        <Title
          title="Pedidos"
          subtitle={getSubtitle()}
          backTo={isMobile ? { url: "/", name: "Tela inicial" } : null}
        >
          <Button
            design="default-icon"
            onClick={() => this.setState({ openFilter: true })}
          >
            <i className="fal fa-calendar" />
          </Button>
          <Button
            design="default-icon"
            onClick={() => this.setState({ openOptions: true })}
            className="ml-10"
          >
            <i className="fal fa-ellipsis-v" />
          </Button>
        </Title>

        <InputSearch
          placeholder="Buscar pedido"
          className="mb-20"
          design="two"
          onChange={debounce(searchByTerm.bind(this), 1000)}
        />

        <If cond={isMobile}>
          <Tabs
            activeTab={activeTab}
            onTabSelected={(i) => this.setState({ activeTab: i })}
            tabs={Object.values(tabs)}
          />
        </If>

        <div className={styles.ordersKanban}>
          {Object.keys(orders).map((key, index) => {
            if (isMobile) {
              if (
                (activeTab === tabs.IN_PRODUCTION.key &&
                  key !== "production") ||
                (activeTab === tabs.ON_DELIVERY.key && key !== "delivery") ||
                (activeTab === tabs.FINISHED.key && key !== "finished")
              )
                return null;
            }

            return (
              <div
                className={`${styles.ordersColumn} column-${index}`}
                key={index}
              >
                <div
                  className={styles.header}
                  key={index}
                  onClick={(e) => scrollTo(e, index)}
                >
                  <div className={styles.icon}>{getIcon(orders[key].id)}</div>
                  <p className={styles.title}>{orders[key].name}</p>
                  <div
                    className={`${styles.quantity} ${
                      [orders[key].id].includes(OrderStatus.FINISHED)
                        ? styles.inactive
                        : styles.active
                    }`}
                  >
                    {orders[key].count}
                  </div>
                </div>

                <div className={styles.orders}>
                  {orders[key].orders.length === 0 && (
                    <p className={styles.empty}>Não há pedidos</p>
                  )}
                  {orders[key].orders.map((order, index) => {
                    return (
                      <OrderCard
                        key={index}
                        order={order}
                        orderGoing={this.state.orderGoing}
                        selectOrder={(order) => selectOrder(order)}
                        onChangeStatus={this.onChangeStatus.bind(this)}
                        allowManualDispatch={this.state.allowManualDispatch}
                        onDispatch={() => this.onDispatch(order)}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        {hasMore && (
          <div className={styles.ordersLoading} ref={this.state.loaderRef}>
            <Loading />
          </div>
        )}
        <Drawer
          visible={openOrderDetails}
          title={`Pedido #${order.displayId}`}
          onClose={(status) => this.setState({ openOrderDetails: false })}
          withoutScroll
        >
          <OrderDetails
            order={order}
            onCancelOrder={(order) => cancelOrder(order)}
          />
        </Drawer>

        <OrderFilterByDate
          closeDrawer={closeDrawer}
          openFilter={openFilter}
          callback={this.searchByDate}
        />

        <Drawer
          visible={openOptions}
          title="Opções"
          footer={
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.saveConfigurations()}
              loading={savingOptions}
              disabled={savingOptions}
            >
              Salvar alterações
            </Button>
          }
          onClose={() => this.setState({ openOptions: false })}
        >
          <Label>Pedidos</Label>
          {UserStorage.isGodMode && (
            <Checkbox
              name="acceptOrdersAuto"
              checked={automaticOrderAccept}
              onChange={(automaticOrderAccept) =>
                this.setState({ automaticOrderAccept: automaticOrderAccept })
              }
            >
              Aceitar pedidos automaticamente
            </Checkbox>
          )}
          <Checkbox
            name="refreshOrdersAuto"
            className="mt-10"
            checked={refreshOrdersAuto}
            onChange={(refreshOrdersAuto) => {
              this.setState({ refreshOrdersAuto: refreshOrdersAuto });
            }}
          >
            Atualizar listagem a cada 1 minuto
          </Checkbox>
          <Checkbox
            name="canceled"
            className="mt-10"
            checked={canceled}
            onChange={(checked) => this.setState({ canceled: checked })}
          >
            Listar somente pedidos cancelados
          </Checkbox>
          <Checkbox
            name="rejected"
            className="mt-10"
            checked={rejected}
            onChange={(checked) => this.setState({ rejected: checked })}
          >
            Listar somente pedidos rejeitados
          </Checkbox>
        </Drawer>

        <OrderCancellationDrawer
          order={order}
          cancellationCodes={orderCancellationCodes}
          visible={openOrderCancellation}
          onClose={() => this.setState({ openOrderCancellation: false })}
        />
      </div>
    );
  }
}
